import type { FaireProductEntity } from "../../entity_types/product";

export const p_35e57a9egy: FaireProductEntity = {
  token: "p_35e57a9egy",
  type: "product",
  name: "Chic Gold Plated Stainless Steel Choker Necklace DP25F852",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/26e8636d83ae94ee995298bf65cdd368b96027e35c403d8baf7777896f5c1440.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ce5909ae1fb31c22862022edc69391d90c3991a36ce02676db86a1c8e82393a.jpeg",
    "https://cdn.faire.com/fastly/097236656e2a07451f962f15860f87c1a8282412eeb6411195fe6f2e5d823419.jpeg",
    "https://cdn.faire.com/fastly/4e8ab762ff02c323a6c6f1f7a28c1f548a9cc52afe6089dcdaeabb2f85b865a3.jpeg",
    "https://cdn.faire.com/fastly/f21bdbd111e4006603dcd975263038d9b78ad3752959f9da1e9c8f9cb2a2d72f.jpeg",
    "https://cdn.faire.com/fastly/e16a132e57239fe1492133e814cf22423c3d0d343e8a79dca8a14b3440363871.jpeg",
    "https://cdn.faire.com/fastly/ee14d3ede9a975ea3d25eddbc81f6104f85408dcd05e6f11195834a8df97fe32.jpeg",
    "https://cdn.faire.com/fastly/8a78d5a719a39c81bfaf8ba6729ae32b4498e436ab2b946ccb26e1c1bf7a06c9.jpeg",
    "https://cdn.faire.com/fastly/493af828f5f68d705359669350d266fdbf071a7f37fd30fe374b137eefb0c20d.jpeg",
    "https://cdn.faire.com/fastly/fd253a1f3ebeb0f262258c8dada289e85efa898bc9572d8e0b8051f6afb9e5b4.jpeg",
    "https://cdn.faire.com/fastly/02b334231709bbd3963d11200e9ad1da29218b806637012c5fc537a20a855734.jpeg",
    "https://cdn.faire.com/fastly/1c861ca768ecafc2a13c1c75e424f93c04a54a43aa7840868439a754bf6f116f.jpeg",
    "https://cdn.faire.com/fastly/505b9e782eec8a03c556f60055a18e1040bc5f9f4917b49b7516e9269395fb8d.jpeg",
    "https://cdn.faire.com/fastly/d3a49a47170f6a3c9bde1d3bdc16f423ecdee55654ed9d4a7bbb1a2e75eb776b.jpeg",
  ],
  priceDollars: 9.41,
  description:
    "Feature:\n * Gold Plated\n * Star, Heart Pendant\n * Non-Tarnish\n * Waterproof\n * Hypoallergenic\n * Lightweight\n * Adjustable\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 10g\n\n Material:\n * Stainless Steel\n\n Package:\n * Package include 1 necklace.\n\n Note:\n * Avoid contact water, perfumes, and chemicals. Store in a dry, cool place and keep away from direct sunlight.\n * Remove before swimming, bathing, or exercising.\n * To clean, gently wipe with a soft, dry cloth.",
  tags: [],
  msrpDollars: 18.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:29.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
